<app-card-badge class="badge" [color]="statusStyle()?.color" *ngIf="status()">
  {{ statusStyle()?.name }}
</app-card-badge>
